<template>
  <div class="maincontainer">
  	<h5>{{$t('plantcare.title')}}</h5>
    <table>
      <thead>
        <tr>
        	 <th v-on:click="set_order('number')">
              <span>{{$t('plantcare.number')}}</span>
              <i class="material-icons dp6" v-if="orderby == 'number' && order == 'desc'">arrow_drop_down</i>
              <i class="material-icons dp6" v-if="orderby == 'number' && order == 'asc'">arrow_drop_up</i>
            </th>
            <th v-on:click="set_order('date')" style="width: 20%;">
              <span>{{$t('plantcare.intervention_date')}}</span>
              <i class="material-icons dp6" v-if="orderby == 'date' && order == 'desc'">arrow_drop_down</i>
              <i class="material-icons dp6" v-if="orderby == 'date' && order == 'asc'">arrow_drop_up</i>
              <select v-model="rangeSelected">
                <option value="currentMonth">{{$t('calendar.current_month')}}</option>
                <option value="prevMonth">{{$t('calendar.prev_month')}}</option>
                <option value="lastThreeMonths">{{$t('calendar.last_three_months')}}</option>
                <option value="currentYear">{{$t('calendar.current_year')}}</option>
                <option value="prevYear">{{$t('calendar.previous_year')}}</option>
                <option value="other">{{$t('calendar.other_range')}}</option>
              </select>
              <div class="row" v-if="rangeSelected == 'other'">
                <div class="col s6 input-field" style="padding-left: 0px;padding-right: 5px; min-width: 13ch;">
                  <input type="date" v-model="fromSelected"/>
                  <button class="waves-effect waves-light btn-large gray" style="border-radius: 8px; line-height: 2.5; height: 35px; padding-left: 0px; padding-right: 0px; width: 100%" v-on:click="cancelChanges()">{{$t('menu.buttons.cancel')}}</button>
                </div>
                <div class="col s6 input-field" style="padding-right: 5px;padding-left: 5px; min-width: 13ch;">
                  <input type="date" v-model="toSelected"/>
                  <button class="waves-effect waves-light btn-large green" style="border-radius: 8px; line-height: 2.5; height: 35px; padding-left: 0px; padding-right: 0px; width: 100%" v-on:click="applyChanges()">{{$t('calendar.apply')}}</button>
                </div>
              </div>
            </th>
            <th v-on:click="set_order('address')">
              <span>{{$t('plantcare.address')}}</span>
              <i class="material-icons dp6" v-if="orderby == 'address' && order == 'desc'">arrow_drop_down</i>
              <i class="material-icons dp6" v-if="orderby == 'address' && order == 'asc'">arrow_drop_up</i>
              <div class="input-field"></div>
            </th>
            <th v-on:click="set_order('pest')">
              <span>{{$t('plantcare.pest')}}</span>
              <i class="material-icons dp6" v-if="orderby == 'tags' && order == 'desc'">arrow_drop_down</i> 
              <i class="material-icons dp6" v-if="orderby == 'tags' && order == 'asc'">arrow_drop_up</i>
              <div class="input-field"></div>
            </th>
            <th>
              <span>{{$t('plantcare.parcel_area')}}</span>
            </th>
            <th>
              <span>{{$t('plantcare.parcel_area_applied')}}</span>
            </th>
            <th>
              <span>{{$t('plantcare.parcel_no')}}</span>
            </th>
            <th v-on:click="set_order('worker_name')">{{$t('plantcare.done_by')}}
            <i class="material-icons dp6" v-if="orderby == 'worker_name' && order == 'desc'">arrow_drop_down</i> 
              <i class="material-icons dp6" v-if="orderby == 'worker_name' && order == 'asc'">arrow_drop_up</i>
              <selector v-model="selected_workers" :items="workerItems" identifier="workerselector" v-if="loaded"></selector>
              </th>
            <th>{{$t('plantcare.weather_conditions')}}</th>
            <th>{{$t('plantcare.plantsinfo')}}</th>
            <th>{{$t('plantcare.protocol')}}</th>
        </tr>
      </thead>

      <tbody v-if="loaded">
        <template  v-for="(dosage, index) in listItems">
        <tr >
          <td>
          	{{dosage.number}}
          </td>
          <td>{{dosage.date | formatDate}}</td>
          <td>{{dosage.address.street}}, {{dosage.address.postal_code}} {{dosage.address.city}}</td>
          <td style="white-space: nowrap;">{{dosage.about}}</td>
          <td>{{dosage.total_area_in_ha}} ha</td>
          <td>{{dosage.used_area_in_ha}} ha</td>
          <td>{{dosage.parcel_number}}</td>
          <td>{{dosage.worker}}</td>
          <td>{{dosage.weather_conditions}}</td>
          <td>{{dosage.plantsinfo}}</td>
          <td>
            <a :href="'#/interventions/'+dosage.id"> <i class="material-icons dp6">equalizer</i> </a>
          </td>
        </tr>
       
        </template>
      </tbody>
      <preloader v-if="loaded == false" n="11"/>
    </table>
    <template v-if="listItems.length == 0 && loaded">
      <p style="font-size: 12px;">{{$t('plantcare.no_protocols')}}</p>
    </template>
  </div>
</template>

<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import moment from 'moment';
export default {
  data: function () {
    return {
      order: 'desc',
      orderby: 'date',
      places: [],
      loaded: false,
      selected_workers: [],
      workerItems: [],
      rangeSelected: "currentMonth",
      lastRange: "currentMonth",
      from: moment().startOf("month"),
      to: moment().endOf("month"),
      fromSelected: moment().startOf("month").format("YYYY-MM-DD"),
      toSelected: moment().endOf("month").format("YYYY-MM-DD"),
      customersearch: "",
      notionssearch: ""
    }
  },
  created() {
    var that = this;
    this.fetch_places(moment(that.from), moment(that.to));
    axios.get('/inspections/last.json').then(response => {
      if(response.data != null){
        var last_time = moment(response.data * 1000);
        if(last_time.isBetween(moment().startOf("month"), moment().endOf("month"))) that.rangeSelected = "currentMonth";
        else if(last_time.isBetween(moment().subtract(1,'months').startOf("month"), moment().subtract(1,'months').endOf("month"))) that.rangeSelected = "prevMonth";
        else if(last_time.isBetween(moment().subtract(3,'months').startOf("month"), moment().endOf("month"))) that.rangeSelected = "lastThreeMonths";
        else if(last_time.isBetween(moment().startOf("year"), moment().endOf("year"))) that.rangeSelected = "currentYear";
        else if(last_time.isBetween(moment().subtract(1,'years').startOf("year"), moment().subtract(1,'years').endOf("year")))
          that.rangeSelected = "prevYear";
        else{
          that.from = last_time.clone().startOf("month").format("YYYY-MM-DD")
          that.fromSelected = last_time.clone().startOf("month").format("YYYY-MM-DD")
          that.to = last_time.clone().endOf("month").format("YYYY-MM-DD")
          that.toSelected = last_time.clone().endOf("month").format("YYYY-MM-DD")
          that.rangeSelected = "other";
        }
      }
      that.loaded = true;
    });
  },
  watch: {
    rangeSelected: function (val) {
      if(val == "currentMonth"){
        this.lastRange = val;
        this.from = moment().startOf("month").format("YYYY-MM-DD")
        this.fromSelected = moment().startOf("month").format("YYYY-MM-DD")
        this.to = moment().endOf("month").format("YYYY-MM-DD")
        this.toSelected = moment().endOf("month").format("YYYY-MM-DD")
      }else if(val == "prevMonth"){
        this.lastRange = val;
        this.from = moment().subtract(1,'months').startOf("month").format("YYYY-MM-DD")
        this.fromSelected = moment().subtract(1,'months').startOf("month").format("YYYY-MM-DD")
        this.to = moment().subtract(1,'months').endOf("month").format("YYYY-MM-DD")
        this.toSelected = moment().subtract(1,'months').endOf("month").format("YYYY-MM-DD")
      }else if(val == "lastThreeMonths"){
        this.lastRange = val;
        this.from = moment().subtract(3,'months').startOf("month").format("YYYY-MM-DD")
        this.fromSelected = moment().subtract(3,'months').startOf("month").format("YYYY-MM-DD")
        this.to = moment().endOf("month").format("YYYY-MM-DD")
        this.toSelected = moment().endOf("month").format("YYYY-MM-DD")
      }else if(val == "currentYear"){
        this.lastRange = val;
        this.from = moment().startOf("year").format("YYYY-MM-DD")
        this.fromSelected = moment().startOf("year").format("YYYY-MM-DD")
        this.to = moment().endOf("year").format("YYYY-MM-DD")
        this.toSelected = moment().endOf("year").format("YYYY-MM-DD")
      }else if(val == "prevYear"){
        this.lastRange = val;
        this.from = moment().subtract(1,'years').startOf("year").format("YYYY-MM-DD")
        this.fromSelected = moment().subtract(1,'years').startOf("year").format("YYYY-MM-DD")
        this.to = moment().subtract(1,'years').endOf("year").format("YYYY-MM-DD")
        this.toSelected = moment().subtract(1,'years').endOf("year").format("YYYY-MM-DD")
      }
      this.loaded = false;
      this.fetch_places(moment(this.from), moment(this.to))
    },
  },
  methods: {
    fetch_places: function(a, b){
      axios.get('/plantcare/'+a.unix()+'/'+b.unix()+'.json').then(response => {
        this.places = response.data;
        for(var i in this.places){
          var item = this.places[i];
          item.fraction = item.total / item.out_of
          if(item.worker_name != null){
            this.workerItems.push({value: item.worker_name, name: item.worker_name});
          } 
        }
        this.workerItems = _.uniqBy(this.workerItems, itm => {
          return itm.value;
        });
        this.loaded = true;
      })
    },
    collapse : function(customer){
      inspection.collapsed = !(inspection.collapsed);
      this.$forceUpdate();
    },
    set_order: function(order){
      if(this.orderby == order){
        if(this.order == 'desc'){
          this.order = 'asc'
        }else if(this.order == 'asc'){
          this.order = 'desc'
        }
        
      }else{
        this.orderby = order;
      }
    },
    applyChanges: function(){
      this.from = this.fromSelected;
      this.to = this.toSelected;
      this.fetch_places(moment(this.from), moment(this.to))
    },
},
computed: {
    listItems() {
      var that = this;
      return _.filter(
        _.orderBy(that.places, that.orderby, that.order),
        function(item){
          return item;
        }
      );
    },
},
mixins: [Vue2Filters.mixin],
}
</script>

<style scoped>
.login_button{
  color: red;
}
.maincontainer{
  padding-top: 33px;
  margin: 33px;
}
p {
  font-size: 2em;
  text-align: center;
}
thead{
  background-color: #DADADA;
}
thead th{
  font-weight: 300;
  padding-top: 5px;
  padding-bottom: 5px;
}
thead .input-field{
  margin-top: unset;
  margin-bottom: unset;
}
select {
  display: block;
  padding-top: 0px;
  padding-bottom: 0 0 0 0;
  height: 35px;
  border-radius: 4px !important;
  border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
}
th {
  vertical-align: baseline;
}
.maincontainer td {
    padding-left: 10px;
    padding-right: 10px;
}
</style>
